import cx from 'classnames'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import type { StickyNote } from '@/types/models'
import { SearchEntity } from '../../hooks/useSearch'
import css from '../../Result.module.scss'

type Props = {
  notes: Record<string, StickyNote>
  selectedItemId: string | null
  onClick: (entity: SearchEntity, payload: any) => void
  hideTitle?: boolean
}

const Notes: React.FC<Props> = ({
  notes,
  selectedItemId,
  onClick,
  hideTitle,
}) => {
  const handleClick = (note: StickyNote) => () => {
    sendGtmEvent(
      GtmTriggerName.SEARCH_RESULT_CLICK,
      'Sticky note result clicked'
    )
    sendGtmEvent(GtmTriggerName.SEARCH_NOTE_CLICK, 'Sticky note result clicked')
    onClick(SearchEntity.NOTE, note)
  }

  return (
    <div>
      {Object.keys(notes).length > 0 && (
        <div>
          {!hideTitle && <div className={css.title}>Sticky Notes</div>}

          <div className={css.list}>
            {Object.entries(notes).map(([id, note]) => (
              <div
                key={note.id}
                className={cx(css.item, {
                  [css.selected]: selectedItemId === id,
                })}
                onClick={handleClick(note)}
              >
                <div>{note.content}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Notes
